import type { ApprovalChain } from '../approval-chain.model';

export const DEED_SUBDIVISION_CHAIN: ApprovalChain = {
  id: 'deed-subdivision',
  label: 'Subdivision/Deduction',
  applicationTypes: ['DEED_SUBDIVISION'],
  steps: [
    { role: 'FINANCE_OFFICER', action: 'Approve Payment', from: ['SUBMITTED', 'RESUBMITTED'], to: 'FINANCE_APPROVED' },
    { role: 'EXAMINER', action: 'Recommend', from: ['FINANCE_APPROVED'], to: 'EXAMINER_RECOMMENDED' },
    { role: 'REGISTRAR', action: 'Approve', from: ['EXAMINER_RECOMMENDED'], to: 'REGISTRAR_APPROVED' },
    { role: 'SURVEYOR_GENERAL_TECHNICIAN', action: 'Recommend', from: ['REGISTRAR_APPROVED'], to: 'SG_TECHNICIAN_RECOMMENDED' },
    { role: 'SURVEYOR_GENERAL', action: 'Approve', from: ['SG_TECHNICIAN_RECOMMENDED'], to: 'APPROVED' },
  ],
};
